export default '/build/d5c51b1d.png'